/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { ArrowDRadiusUpLeftIcon16Light } from './ArrowDRadiusUpLeftIcon16Light';
import { ArrowDRadiusUpLeftIcon16Regular } from './ArrowDRadiusUpLeftIcon16Regular';
import { ArrowDRadiusUpLeftIcon16Solid } from './ArrowDRadiusUpLeftIcon16Solid';
import { ArrowDRadiusUpLeftIcon20Light } from './ArrowDRadiusUpLeftIcon20Light';
import { ArrowDRadiusUpLeftIcon20Regular } from './ArrowDRadiusUpLeftIcon20Regular';
import { ArrowDRadiusUpLeftIcon20Solid } from './ArrowDRadiusUpLeftIcon20Solid';
import { ArrowDRadiusUpLeftIcon24Regular } from './ArrowDRadiusUpLeftIcon24Regular';
import { ArrowDRadiusUpLeftIcon24Solid } from './ArrowDRadiusUpLeftIcon24Solid';
import { ArrowDRadiusUpLeftIcon32Regular } from './ArrowDRadiusUpLeftIcon32Regular';
import { ArrowDRadiusUpLeftIcon64Regular } from './ArrowDRadiusUpLeftIcon64Regular';
var sizes = {
    16: {
        light: ArrowDRadiusUpLeftIcon16Light,
        regular: ArrowDRadiusUpLeftIcon16Regular,
        solid: ArrowDRadiusUpLeftIcon16Solid,
    },
    20: {
        light: ArrowDRadiusUpLeftIcon20Light,
        regular: ArrowDRadiusUpLeftIcon20Regular,
        solid: ArrowDRadiusUpLeftIcon20Solid,
    },
    24: {
        regular: ArrowDRadiusUpLeftIcon24Regular,
        solid: ArrowDRadiusUpLeftIcon24Solid,
    },
    32: {
        regular: ArrowDRadiusUpLeftIcon32Regular,
    },
    64: {
        regular: ArrowDRadiusUpLeftIcon64Regular,
    },
};
export var ArrowDRadiusUpLeftIcon = forwardRef('ArrowDRadiusUpLeftIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
